import * as React from 'react';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { classNames } from '@egds/react-core/utils';
import styles from '../../../../../styles/egds-app-growth-sheet-server-side-render.css';
import { defineSheetLayout, setElementFocus, hasSheetClassName, trapUpperBoundFocus, trapLowerBoundFocus } from '../sheet-server-side-render-utilities/index.esm.js';

// For focus trapping
const getClassNameList = classNames.bind(styles);
const EGDSFullSheetServerSideRender = props => {
  const {
    ariaLabel,
    autoFocus = true,
    children,
    className,
    theme = 'dark',
    type = 'full',
    isVisible,
    ...attributes
  } = props;
  const sheetRef = React.useRef(null);
  const baseClassName = `egds-${type}-server-sheet`;
  const sheetClassNames = getClassNameList(baseClassName, className, `${baseClassName}-${theme}`);
  const {
    hasCloseButton,
    layoutProps,
    closeButtonLayoutProps,
    closeButtonElem,
    childrenElem
  } = defineSheetLayout(children);
  // Hooks
  React.useEffect(() => {
    if (autoFocus && isVisible) {
      setElementFocus(sheetRef);
    }
    isVisible && hasSheetClassName('add');
  }, [isVisible, autoFocus]);
  // "unmount" hook
  React.useEffect(() => () => {
    hasSheetClassName('remove');
  }, []);
  return React.createElement("section", {
    ref: sheetRef,
    className: sheetClassNames,
    tabIndex: -1,
    role: "dialog",
    "aria-label": ariaLabel,
    ...attributes
  }, React.createElement("div", {
    tabIndex: 0,
    onFocus: trapUpperBoundFocus,
    "aria-hidden": "true"
  }), hasCloseButton && React.createElement(EGDSLayoutFlex, {
    ...layoutProps
  }, React.createElement(EGDSLayoutFlexItem, {
    ...closeButtonLayoutProps
  }, React.createElement("div", null, closeButtonElem)), childrenElem && React.createElement(EGDSLayoutFlexItem, null, childrenElem)), !hasCloseButton && childrenElem, React.createElement("div", {
    tabIndex: 0,
    onFocus: trapLowerBoundFocus,
    "aria-hidden": "true"
  }));
};
EGDSFullSheetServerSideRender.displayName = 'EGDSFullSheetServerSideRender';
export { EGDSFullSheetServerSideRender };